import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { ReactComponent as ArrowExternalWhite } from 'images/arrow-external-white.svg'

export default function Link({ id, children, className, style, to, href, url, arrow }){
    const destination = url?url : to?to : href?href : '#'
    
    if (destination.startsWith('http')){
        return (
            <a
                id={id}
                href={destination}
                rel='noreferrer'
                target='_blank'
                className={className}
                style={style}
                css={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                {children}
                {(arrow !== false) && (
                    <span
                        className='p-rel'
                        style={{ bottom: 4 }}
                    >
                        <ArrowExternalWhite />
                    </span>
                )}
            </a>
        )
    } else {
        return (
            <GatsbyLink
                id={id}
                to={destination}
                className={className}
                style={style}
            >
                {children}
            </GatsbyLink>
        )
    }
}
